<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ik00DH/tc-custom/9781440526558.jpg?1730542028376" alt="This image is the cover for the book Uncommon Courtesy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncommon Courtesy
      </h1>
      <p class="bookDescription body article font2">
        <p>This book is the short slap to the back of the head most people need nowadays. In a world that's more likely to flip the bird than hold the door, it's their reminder of proper behavior. You'll receive a (re-)schooling in manners with lessons split up by situation, then tackled by topic. Each note corrects conduct that's become all too common, like . . .<br/><br/><b>Bad Behavior</b>: Popping a piece of gum into your mouth midconversation, and stressing your point by snapping it.<br/><br/><b>Courteous Fix</b>: If you're going to have a piece of gum while talking to someone, be sure to offer your companion a piece--and keep your mouth closed as you chew. You want your breath to be fresh. Not your attitude.<br/><br/>It's a reminder that it wasn't always out of place to be polite.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer M. Wood
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9cfd13ee